export var developers = [
    {
        id: 0,
        roll_no: 2317007,
        name: "Gurcharan Kohli",
        image: "/assets/images/gurcharan.jpg",
        email: "gurcharankohli1000@gmail.com",
        skills: "React, DBMS, C++, Machine Learning, Python"
    },
    {
        id: 1,
        roll_no: 2317010,
        name: "Utkarsh Bansal",
        image: "/assets/images/uts.jpg",
        email: "utkarshbansal210@gmail.com",
        skills: "React, Python, JavaScript, Front-End Web Development, DBMS"
    },
    {
        id: 2,
        roll_no: 2317011,
        name: "Yogantar Chhibber",
        image: "/assets/images/yogantar.jpg",
        email: "yugantarc@gmail.com",
        skills: "Illustration, UI Design, Logo Design, Vector Design, C, C++, Python"
    },
    {
        id: 3,
        roll_no: 2317018,
        name: "Manpreet Singh",
        image: "/assets/images/manpreet.jpeg",
        email: "goldieeyou@gmail.com",
        skills: "Programming in C, C++, Python"
    }
]